<template>
  <div :class="['waiting',isActive ? 'active':'']" @click="onScreenClick" id="waiting1">
    <div class="waitElements">
        <div class="waitLogo">
            <img src="images/mis.svg">
        </div>
        <div class="waitText">Click to start</div>
    </div>    
  </div>
</template>

<style scoped>
    .waiting
    {
        width: 100vw;
        height: 100vh;
        display: flex;
        align-content: center;
        align-items: center;
        opacity: 0;
        transition: all ease 0.5s;
    }
    .waiting.active
    {
        opacity: 1;
    }
    .waiting .waitElements
    {
        color: #fff;
        margin: auto;
    }
    .waitLogo
    {
        padding-bottom: 20px;
    }
    .waitLogo img
    {
        width: 300px;
        height: auto;
    }
    .waitText
    {
        text-align: center;
    }
</style>


<script>
    import { mapState, mapGetters, mapActions } from "vuex";
    //import Screen from "@/components/Screen.vue";
    export default 
    {
        computed:
        {
            ...mapState(["appData"])
        },
        data()
        {
            return{
                isActive:true
            }
        },
        mounted()
        {
            var vm = this;
            window.onresize = function() {
                vm.setScreenHeight();
            };
            vm.setScreenHeight();
        },
        created()
        {
            this.setScreenHeight();
        },
        methods:
        {        
            setScreenHeight()
            {                
                if(window.innerWidth<1000)
                {
                    let waitingScreenElement = document.getElementById("waiting1");
                    if(waitingScreenElement)
                    {
                        waitingScreenElement.style.height = window.innerHeight + "px";
                    }                
                }
            },
            onScreenClick()
            {
                //close screen and open menu
                this.isActive = false;
                setTimeout(() => {
                    this.$emit('onClick');    
                }, 800);                
            }
        }
    };
</script>